// extracted by mini-css-extract-plugin
module.exports =  {"input-param":"input-param--uQn_R","inputParam":"input-param--uQn_R"};